"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEMBERS = exports.REMOTE_IDS = exports.REMOTES = exports.INVITES = exports.ACCOUNT_DOC_ID = exports.ACCOUNT = exports.PROJECTLAYOUTS = exports.PROJECTS = exports.TASKLISTS = exports.TASKCOMMENTS = exports.TASKS = exports.JOBS_QUEUE = exports.USERS = exports.DIRECTORY = void 0;
// Firestore Path References.
var DIRECTORY = "directory";
exports.DIRECTORY = DIRECTORY;
var USERS = "users";
exports.USERS = USERS;
var JOBS_QUEUE = "jobsQueue";
exports.JOBS_QUEUE = JOBS_QUEUE;
var TASKS = "tasks";
exports.TASKS = TASKS;
var TASKCOMMENTS = "taskComments";
exports.TASKCOMMENTS = TASKCOMMENTS;
var TASKLISTS = "taskLists";
exports.TASKLISTS = TASKLISTS;
var PROJECTS = "projects";
exports.PROJECTS = PROJECTS;
var PROJECTLAYOUTS = "projectLayouts";
exports.PROJECTLAYOUTS = PROJECTLAYOUTS;
var ACCOUNT = "account";
exports.ACCOUNT = ACCOUNT;
var ACCOUNT_DOC_ID = "primary";
exports.ACCOUNT_DOC_ID = ACCOUNT_DOC_ID;
var INVITES = 'invites';
exports.INVITES = INVITES;
var REMOTES = 'remotes';
exports.REMOTES = REMOTES;
var REMOTE_IDS = 'remoteIds';
exports.REMOTE_IDS = REMOTE_IDS;
var MEMBERS = 'members';
exports.MEMBERS = MEMBERS;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-firebase/paths/index.js
// module id = 1057
// module chunks = 0